import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { OrderMenu } from '../../_models/orderMenu';
import { Subject } from 'rxjs';
import { Caller } from '../../_models/caller';
import { AlertService } from '../../_services/alert.service';
import * as _ from "lodash";
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-admin-orders',
  templateUrl: './admin-orders.component.html',
  styleUrls: ['./admin-orders.component.css']
})
export class AdminOrdersComponent implements OnInit {
  ordersMainMenu: OrderMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N" },
    { displayName: "New", tabClicked: "submitted", orderStatus: "SUBMITTED", additional: "N" },
    { displayName: "Ready to Ship", tabClicked: "readyToShip", orderStatus: "READY_TO_SHIP", additional: "N" },
    { displayName: "In Transit", tabClicked: "shipped", orderStatus: "IN_TRANSIT", additional: "N" },
    { displayName: "Delivered", tabClicked: "Delivered", orderStatus: "DELIVERED", additional: "N" },
    { displayName: "RTO (Return to Origin)", tabClicked: "RTO", orderStatus: "RTO", additional: "Y" },
    { displayName: "Hold", tabClicked: "onHold", orderStatus: "ON_HOLD", additional: "Y" },
    { displayName: "Cancelled", tabClicked: "Cancelled", orderStatus: "CANCELLED", additional: "Y" }
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  noOfBoxesArray = [];
  myAngularxQrCode: string = null;
  modalPickLine: any = {};
  orders: any;
  grant: any;
  tabSelection: any = {};
  orderStatusValue: string;
  tabClicked: string;
  headerDetails: any;
  orderDraft: any;
  codeList: string[] = [
    '', 'CODE128',
    'CODE128A', 'CODE128B', 'CODE128C',
    'UPC', 'EAN8', 'EAN5', 'EAN2',
    'CODE39',
    'ITF14',
    'MSI', 'MSI10', 'MSI11', 'MSI1010', 'MSI1110',
    'pharmacode',
    'codabar'
  ];
  elementType = 'svg';
  value = 'someValue12340987';
  format = 'CODE128';
  lineColor = '#000000';
  width = 2;
  height = 100;
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'center';
  textPosition = 'bottom';
  textMargin = 2;
  fontSize = 20;
  background = 'transparent';
  margin = 10;
  marginTop = 10;
  marginBottom = 10;
  marginLeft = 10;
  marginRight = 10;
  awb: any = {
    tracking_data: "",
    track_status: "",
    shipment_status: "",
    shipment_track: [],
    shipment_track_activities: []
  };
  uploadPopup: string = "";
  uploadDismissModal: string = "";
  userDrop: string;
  statusText1: string = "";
  statusText2: string = "";
  productImage: string = "";
  checkedList: any;
  masterSelected: boolean = false;
  errorMessage: string;
  barCodeValue: string = '';
  productList: any = [];
  popUpAssign: string = 'N';
  popUpGenerate: string = 'N';
  pickSlipPopUp: string = 'N';
  assignValue: any;
  userList: any = [];
  orderStatus: any = 'ALL';
  userDrop2: any = 'ALL';
  totalRecords: number;
  previousStatus = '';
  ohid: any;
  sizeError: string;
  size: string;
  pdfGenerate: string = 'N';
  pickSlipPDF: string = 'N';
  pickSlipSize: string;
  pickSlipSizeError: string;
  toDayDateAndTime = new Date().toLocaleString();

  constructor(private alertService: AlertService, private excelService: ExcelServiceService, private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public caller: Caller) {
    this.g.page = "Orders View";
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.ordersMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.orders.length; i++) {
      this.orders[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  populate(orderChange) {
    this.g.loaderDisplay = "display";
    this.api.getStockTransferList(orderChange, "ORDER", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.ordersData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList.push(this.orders[i]['orderHeaderId']);
      }
    }
  }


  getAllAdminUsers() {
    this.g.loaderDisplay = "display";
    let query = { organizationId: 1, role: 'WORK_MEN', status: 'ALL' };
    this.api.getAllAdminUsersByRole("1", "ACTIVE", query).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.userList = data.getAccountOwnerUserResponseList;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    } else {
      this.rerender();
    }
  }

  getOrdersByStatus(status) {
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Order # / Channel Order # / Phone Number / Email'
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          orderType: 'ORDER',
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.get(environment.apiUrl + "api/getOrderConsignmentsByStatus", { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.orders = resp.ordersData;
            this.g.loaderDisplay = "";
            this.totalRecords = resp.noOfOrders;
            this.orders.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfOrders,
              recordsFiltered: resp.noOfOrders
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };

  }

  closePickSlipPop() {
    this.pickSlipPopUp = 'N';
    this.errorMessage = "";
  }

  pickDetailes(pickLine) {
    this.g.loaderDisplay = "display";
    this.api.getGeneratedPickSlip(pickLine.orderHeaderId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.pickSlipPopUp = 'Y';
      this.modalPickLine = data;
      this.rerender();
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });

  }

  close() {
    this.pdfGenerate = 'N';
    this.populateTabData('readyToShip', "READY_TO_SHIP");
  }

  closePickSlipPdf() {
    this.pickSlipPDF = 'N';
    this.populateTabData('pick', "TO_PICK");
  }

  printShipment() {
    console.log(this.ohid)

    this.sizeError = "";

    if (!this.size) {
      this.sizeError = 'Please select size';
    }

    if (this.sizeError != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generateShippingLabelPDF', {
      "headerId": this.ohid.orderHeaderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.ohid.accountOwnerId,
      "size": this.size
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ob_' + this.ohid.orderNumber + '_shipping_label_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pdfGenerate = 'N';
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }


  printPickSlip() {
    console.log("printPickSlipDetails::" + this.ohid);

    this.pickSlipSizeError = "";

    if (!this.pickSlipSize) {
      this.pickSlipSizeError = 'Please select size';
    }

    if (this.pickSlipSizeError != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generatePickSlipPDF', {
      "headerId": this.ohid.orderHeaderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.ohid.accountOwnerId,
      "size": this.pickSlipSize
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ob_' + this.ohid.orderNumber + '_pick_slip_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pickSlipPDF = 'N';
        this.populateTabData('pick', "TO_PICK");
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }


  generateGrant(selectedOrder) {
    if (selectedOrder.shippingOption !== "THIRD_PARTY") {
      this.api.generateShippingLabelForOrders(selectedOrder.orderHeaderId, this.user.organizationId).subscribe((data: any) => {
        this.popUpGenerate = 'Y';
        this.grant = data;
        this.noOfBoxesArray = [];
        this.productList = [];
        if (this.grant.productConfig == 'MULTI_SKU') {
          let boxesObj: any = {};
          for (let i = 1; i <= (this.grant.totalBoxes || 0); i++) {
            boxesObj['boxNumber' + i] = {};
          }
          if ((this.grant || {}).orderLinesList && (this.grant || {}).orderLinesList.length && this.grant.orderLinesList[0].packingConfigList && this.grant.orderLinesList[0].packingConfigList.length && this.grant.orderLinesList[0].packingConfigList[0].noOfBoxes) {
            this.grant.orderLinesList.forEach((f) => {
              if (f.packingConfigList && f.packingConfigList.length) {
                f.packingConfigList.forEach((d) => {
                  boxesObj['boxNumber' + d.boxNumber].height = d['height'];
                  boxesObj['boxNumber' + d.boxNumber].width = d['width'];
                  boxesObj['boxNumber' + d.boxNumber].length = d['length'];
                  boxesObj['boxNumber' + d.boxNumber].weight = d['weight'];
                  if (!boxesObj['boxNumber' + d.boxNumber].pList) {
                    boxesObj['boxNumber' + d.boxNumber].pList = [];
                  }
                  boxesObj['boxNumber' + d.boxNumber].pList.push({
                    'qtyPerBox': d['qtyPerBox'],
                    'noOfBoxes': d['noOfBoxes'],
                    'productName': f['productName'],
                    'sku': f['sku'],
                    'productId': f['productId']
                  });
                });
              }
            });
            for (let j = 1; j <= this.grant.totalBoxes; j++) {
              this.productList.push(boxesObj['boxNumber' + j]);
            }
            console.log(this.productList);
          } else {
            this.productList.push({
              'productName': '',
              'sku': '',
              'productId': '',
              'qtyPerBox': '',
              'noOfBoxes': '',
              'height': '',
              'width': '',
              'length': '',
              'weight': ''
            });
          }
        } else {
          if ((this.grant || {}).orderLinesList && (this.grant || {}).orderLinesList.length && this.grant.orderLinesList[0].packingConfigList && this.grant.orderLinesList[0].packingConfigList.length && this.grant.orderLinesList[0].packingConfigList[0].noOfBoxes) {
            this.grant.orderLinesList.forEach((f) => {
              if (f.packingConfigList && f.packingConfigList.length) {
                f.packingConfigList.forEach((d) => {
                  for (let i = 1; i <= d.noOfBoxes; i++) {
                    this.productList.push({
                      'productName': f['productName'],
                      'sku': f['sku'],
                      'productId': f['productId'],
                      'qtyPerBox': d['qtyPerBox'],
                      'noOfBoxes': d['noOfBoxes'],
                      'height': d['height'],
                      'width': d['width'],
                      'length': d['length'],
                      'weight': d['weight']
                    });
                  }
                });
              }
            });
          } else {
            this.productList.push({
              'productName': '',
              'sku': '',
              'productId': '',
              'qtyPerBox': '',
              'noOfBoxes': '',
              'height': '',
              'width': '',
              'length': '',
              'weight': ''
            });
          }
        }
        this.myAngularxQrCode = this.grant.trackingNumber;
        this.barCodeValue = this.grant.trackingNumber;
        this.rerender();
      }, err => {
        this.alertService.error('Error', err);
      });
    } else {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + 'api/getShipLabelFrmShipRocket?orderHeaderId=' + selectedOrder.orderHeaderId, {},
        { headers: header1 }).subscribe(data => {
          this.checkedList = [];
          this.g.loaderDisplay = "";
          if (data['label_created'] == true) {
            this.alertService.success('Label Generated', 'Proceed Successfully');
            this.rerender();
          } else {
            this.alertService.error('Error', data['message']);
          }
        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
          });
    }
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[4].displayName) {
      this.ordersMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.ordersMainMenu) {
      if (tmp < this.ordersMainMenu.length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  trackByAWB(number) {
    this.api.trackShipmentByAWB(number).subscribe((data: any) => {
      this.awb = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  submitOrder() {
    this.router.navigate(['/admin/createOrders']);
  }

  selectedEditOrder(orders) {
    this.router.navigate(['/admin/editOrder/' + this.checkedList[0]]);
  }

  splitOrder(orders) {
    this.router.navigate(['/admin/splitOrder/' + this.checkedList[0]]);
  }

  exportToPdf(action = 'open') {
    const documentDefinition = this.getDocumentDefinition();
    switch (action) {
      case 'open':
        pdfMake.createPdf(documentDefinition).open();
        break;
      case 'print':
        pdfMake.createPdf(documentDefinition).print();
        break;
      case 'download':
        pdfMake.createPdf(documentDefinition).download();
        break;
      default:
        pdfMake.createPdf(documentDefinition).open();
        break;
    }
  }

  getDocumentDefinition() {
    return {
      pageSize: 'A4',
      pageMargins: [30, 25, 30, 15],
      header: {
        margin: [20, 10, 10, 10],
        columns: [
          { text: this.g.page, alignment: 'center', style: 'tableHeaders', bold: 'true' }
        ]
      },
      content: [
        {
          style: 'tableExample',
          table: {
            widths: [30, 30, 30, 30, 30, 30, 30],
            body: this.getReportsData()
          }
        }
      ],
      styles: {
        content: {
          fontSize: 5
        },
        tableHeaders: {
          fontSize: 8,
          bold: true
        },
        headerText: {
          fontSize: 6,
          color: '#FFFFFF',
          fillColor: '#0074C1',
          bold: true
        }
      }

    };
  }

  getReportsData() {
    let reportsData = [];
    reportsData.push([{ text: 'Order #', style: 'headerText' }, {
      text: 'Channel Order #',
      style: 'headerText'
    }, { text: 'Order Date	', style: 'headerText' }, { text: 'Source', style: 'headerText' }, {
      text: 'Customer',
      style: 'headerText'
    }, { text: 'Contact', style: 'headerText' }, { text: 'Status', style: 'headerText' }]);
    this.orders.forEach((o) => {
      reportsData.push([{ text: o.orderHeaderId, style: 'content' }, {
        text: o.sourceOrderId,
        style: 'content'
      }, { text: o.sourceOrderDate, style: 'content' }, { text: o.channelName, style: 'content' }, {
        text: o.ownerName,
        style: 'content'
      }, { text: o.contactName, style: 'content' }, { text: o.orderStatus, style: 'content' }]);
    });
    return reportsData;
  }

  processMultipleOrders(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected) {
        this.processingOrder(order);
      }
    }
    ;
  }


  pickMultipleOrders(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected && order.accountType !== "DEMO_ACCOUNT") {
        this.toPick(order);
      }
    }
    ;
  }

  exceptionMultipleOrders(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected) {
        this.processingOrder(order);
      }
    }
    ;
  }

  exceptionMultiOrders(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected) {
        this.exceptionOrder(order);
      }
    }
    ;
  }

  readyToGenerateLabel(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/ProcessingOrder/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }


  selectAdjustInventory(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/adjustInventory/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.orders, 'sample');
  }

  generateShippingLabel(orders) {
    let i = 0;

    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.pdfGenerate = 'Y';
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }


  selectGeneratePickSlip(orders) {
    let i = 0;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.pickSlipPDF = 'Y';
    } else {
      this.errorMessage = "Can not Edit multiple Orders at once. Please select one at a time";
    }
  }

  selectAwaitingCarrier(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.awaitingCarrierFunction(ohid);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }


  shipMultipleOrders(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/ProcessingOrder/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  assignedPick(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.assignedPopUp(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }


  assignedReadyToShip(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.readyToShip(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }


  moveToShipped(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.shipping(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }

  validToDisplay(status) {
    let disable = true;
    let checkedList = [];
    if (this.orders && this.orders.length) {
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i].isSelected) {
          checkedList.push(this.orders[i]);
        }
      }
    }
    if (checkedList.length == 1) {
      if (this.tabClicked === 'submitted') {
        if (status === 'Validated' && checkedList[0].inStockStatus) {
          disable = false;
        } else if (status === 'Low Stock' && !checkedList[0].inStockStatus) {
          disable = false;
        }
      }

      if (this.tabClicked === 'pick') {
        if (status === 'Ready to Pick' && checkedList[0].orderStatus === 'TO_PICK') {
          disable = false;
        }
      }
      if (this.tabClicked === 'readyToShip') {
        if (status === 'Carrier to be assigned' && checkedList[0].orderStatus === 'READY_TO_SHIP') {
          disable = false;
        }
        if (status === 'Generate Label' && checkedList[0].orderStatus === 'GENERATE_LABEL') {
          disable = false;
        }
        if (status === 'Label Generated' && checkedList[0].orderStatus === 'LABEL_GENERATED') {
          disable = false;
        }
      }
      if (this.tabClicked === 'awaitingCarrier') {
        if (status === 'Awaiting Carrier' && checkedList[0].orderStatus === 'AWAITING_CARRIER') {
          disable = false;
        }
        if (status === 'shipped' && checkedList[0].orderStatus === 'SHIPPED') {
          disable = false;
        }
      }
      if (this.tabClicked === 'completed') {
        if (status === 'shipped' && checkedList[0].orderStatus === 'COMPLETED') {
          disable = false;
        }
      }
    } else if (checkedList.length > 1) {
      let i = 0;
      checkedList.forEach((s) => {

        if (this.tabClicked === 'submitted') {
          if (status === 'Validated' && s.inStockStatus) {
            disable = false;
            i = i + 1;
          } else if (status === 'Low Stock' && !s.inStockStatus) {
            disable = false;
            i = i + 1;
          }
          if (i !== checkedList.length) {
            disable = true;
          }
        }
      });
    } else {
      disable = true;
    }

    return disable;
  }

  moveToInTransit(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.inTransit(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }

  assignedPopUp(p) {
    this.getAllAdminUsers();
    this.assignValue = p;
    this.popUpAssign = 'Y';
  }

  closePopUp() {
    this.popUpAssign = 'N';
  }

  closePopUpGenerate() {
    this.popUpGenerate = 'N';
    this.populateTabData('readyToShip', "READY_TO_SHIP");
  }

  processMultipleOrdersCompleted(orders) {
    this.checkedList = [];
    for (let order of orders) {
      if (order.isSelected) {
        this.completed(order);
      }
    }
    ;
  }

  processingOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "PROCESSING",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Processing Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  awaitingCarrierFunction(ord) {

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    if (ord.shippingOption !== "THIRD_PARTY") {
      this.g.loaderDisplay = "display";

      this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
        "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
        "orderStatus": "AWAITING_CARRIER",
        "organizationId": 1
      },
        { headers: header1 }).subscribe(data => {
          this.checkedList = [];
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {
            this.alertService.success('Order', 'Awaiting Carrier Successfully');

            let index = this.orders.indexOf(ord);
            this.orders.splice(index, 1);
            this.rerender();
          } else {
            this.alertService.error('Error', data['message']);
          }
        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
          });
    } else {
      this.http.post(environment.apiUrl + 'api/pickUpRequestForShip?orderHeaderId=' + ord.orderHeaderId, {}, {
        headers: header1
      }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['pickup_status']) {
          this.alertService.success('PickUp Scheduled On :', data['response'].pickup_scheduled_date);
          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    }
  }


  toPick(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "TO_PICK",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Pick Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  exception(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "EXCEPTION",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Exception Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  readyToShip(ord) {
    if (ord.shippingOption == "SHIFT") {
      this.orderStatusValue = "GENERATE_LABEL";
    } else {
      this.orderStatusValue = "READY_TO_SHIP";
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": this.orderStatusValue,
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Ready to Ship Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  shipping(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": "DELIVERED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Delivered Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  inTransit(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": "SHIPPED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'In shipped Successfully');
          this.populateTabData('awaitingCarrier', "AWAITING_CARRIER");
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  completed(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": "COMPLETED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Completed Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }

  exceptionOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "EXCEPTION",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Exception Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  cancelOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
      "orderStatus": "CANCELLED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Cancelled Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  loadorder(event) {
    this.statusText2 = "";
    this.productImage = event.target.files[0];
  }

  submitImportOrder() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#myModalOne";
    const file = this.productImage;
    if (file == "" || file === null) {
      this.statusText2 = 'please select file';
      this.uploadDismissModal = "";
      this.uploadPopup = "#";
      this.g.loaderDisplay = "";
      return false;
    }
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadFileToSave', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Order', 'Imported Successfully');
        this.rerender();
      } else if (data['code'] == 400) {
        this.statusText1 = data['message'];
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
        return false;
      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
      });
  }

  returnOrders(orders) {
    this.router.navigate(['/admin/returnOrder/' + this.checkedList[0]]);
  }

  submitAssign() {
    if (this.userDrop == '' || this.userDrop === null || this.userDrop === undefined || this.userDrop === 'undefined') {
      this.statusText1 = 'Please select Picker';
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/toAssignOrder',
      {
        "organizationId": 1,
        "orgUserId": this.userDrop,
        "orderStatus": "PICK_ASSIGNED",
        "orderHeaderId": this.assignValue.orderHeaderId
      },

      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Assigned Status', 'Submitted  Successfully');

          this.popUpAssign = 'N';
          this.populateTabData('pick', "TO_PICK");
          // this.getOrder("TO_PICK");
          this.closePopUp();

        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });
  }

  generatePdf() {
  }

  cloneOrder() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/cloneOrderHeader?headerId=' + this.checkedList[0] + "&organizationId=1", {},
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Cloned Successfully');
        }
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  copyOrder() {
    this.router.navigate(['/admin/createOrders/' + this.checkedList[0]]);
  }

  removeFile() {
    this.productImage = "";
  }

  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }
}
